import _ from 'lodash';
import React from 'react';
import moment from 'moment';
import uuid4 from 'uuid/v4';

import {DATE_FORMAT_API} from 'utils/datetime';

import {RESOLUTION_OPTIONS} from 'ducks/occupancy';

import './styles.css';

const BAR_MAX_HEIGHT = 200; // in px
class BarColoredSegment extends React.Component<any> {
  render() {
    const {barHeight, type, tooltipData} = this.props;

    const typeCSSClassString = type.split(' ').join('-');

    return (
      <React.Fragment>
        <div
          className={`ChartBar__segment ChartBar__segment--${typeCSSClassString ||
            'unknown'}`}
          style={{
            height: barHeight * BAR_MAX_HEIGHT
          }}
          data-tip={JSON.stringify(tooltipData)}
          data-for="ChartBar__tooltip"
        />
      </React.Fragment>
    );
  }
}

const ChartBar = ({tableColumn, unitsRenderer}) => {
  const calcBarHeight = barSlug =>
    tableColumn.roomPurposeBreakdown[barSlug].value / tableColumn.totalRooms;

  return (
    <div className="ChartBar">
      {Object.keys(tableColumn.roomPurposeBreakdown).map(value => (
        <BarColoredSegment
          key={value}
          barHeight={calcBarHeight(value)}
          type={value}
          unitsRenderer={unitsRenderer}
          tooltipData={tableColumn.roomPurposeBreakdown[value].tooltipData}
        />
      ))}
    </div>
  );
};

class TableCell extends React.Component<any> {
  state = {id: uuid4()};

  render() {
    const {className, value, maxValue, tooltipData, unitsRenderer} = this.props;

    return (
      <React.Fragment>
        <div
          className={className}
          data-tip={JSON.stringify(tooltipData)}
          data-for="ChartBar__tooltip"
          data-delay-show={1000}>
          {unitsRenderer(value, maxValue)}
        </div>
      </React.Fragment>
    );
  }
}

const TableTotalCell = ({value, totalRooms, unitsRenderer}) => {
  return (
    <TableCell
      className="ChartColumn__table__total ChartColumn__table__row ChartColumn__table__row--with-shadow colab-centered"
      value={value}
      maxValue={totalRooms}
      tooltipData={{}}
      unitsRenderer={unitsRenderer}
    />
  );
};

const ChartColumnLabel = ({date, resolution}) => {
  let label: string = '';
  let subLabel: string = '';

  if (resolution === RESOLUTION_OPTIONS.DAILY) {
    label = date.format('ddd'); // Mon, Thu, ... Sun
    subLabel = date.format('DD/MM/YY');
  }

  if (resolution === RESOLUTION_OPTIONS.WEEKLY) {
    label = date.format('MMM'); // Jan, Feb, ... Dec
    subLabel = date.format('DD/MM/YY');
  }

  if (resolution === RESOLUTION_OPTIONS.MONTHLY) {
    label = date.format('MMM'); // Jan, Feb, ... Dec
    subLabel = moment(date, DATE_FORMAT_API)
      .year()
      .toString();
  }

  return (
    <div className="ChartColumn__label">
      <div className="colab-bold">{label}</div>
      <p>{subLabel}</p>
    </div>
  );
};

const ChartColumn = ({
  tableColumn,
  tableHeaders,
  unitsRenderer,
  resolution
}) => (
  <div className="ChartColumn">
    <div className="ChartColumn__bar">
      <ChartBar tableColumn={tableColumn} unitsRenderer={unitsRenderer} />
    </div>
    <ChartColumnLabel date={tableColumn.date} resolution={resolution} />
    <div className="ChartColumn__table">
      <TableTotalCell
        value={tableColumn.totalOccupancy}
        totalRooms={tableColumn.totalRooms}
        unitsRenderer={unitsRenderer}
      />
      {tableHeaders.map(group => (
        <TableCell
          key={uuid4()}
          className="ChartColumn__table__row ChartColumn__table__row--with-shadow colab-centered"
          value={tableColumn.roomPurposeBreakdown[group.ref].value}
          maxValue={tableColumn.roomPurposeBreakdown[group.ref].maxValue}
          tooltipData={{} /*group.tooltipData*/}
          unitsRenderer={unitsRenderer}
        />
      ))}
    </div>
  </div>
);

export default ChartColumn;
